/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { string, bool } from 'prop-types';

import DisclosureModal from './DisclosureModal';

import './CardDisclosureModal.scss';

export default class CardDisclosureModal extends DisclosureModal {
  containerClassName() {
    return (
      'modal-info-container modal-disclosure-container card-disclosure-action ' +
      (this.props.className || '')
    );
  }
}

CardDisclosureModal.propTypes = {
  className: string,
  content: string,
  hideLinkContent: bool
};

CardDisclosureModal.defaultProps = {
  hideIcon: true,
  hideLinkContent: false
};
